module.exports = __webpack_public_path__ + "../resources/images/emptySearch-8f7d843f2b4438779a13c37f86af8dd4.svg";